import classNames from 'classnames';
import { forwardRef, ReactNode, Ref } from 'react';
import useAnimateInOutComponent from '@alltrails/core/hooks/useAnimateInOutComponent';
import styles from './LayerLegendContainer.module.scss';

// https://www.figma.com/design/6lD2rWP01sgcuqzuhG6EXK/Conditions-%2F-Overlays-2.0-Web-(Handoff)?node-id=93-29360

type Props = {
  buttonLabel?: string;
  children: ReactNode;
  className?: string;
  isOpen: boolean;
  onClick?: () => void;
  testIdPrefix: string;
};

const LayerLegendContainer = forwardRef<HTMLElement, Props>(({ buttonLabel, children, className, isOpen, onClick, testIdPrefix }, ref) => {
  const { isAnimating, isVisible, onAnimationEnd } = useAnimateInOutComponent(isOpen);

  if (!isAnimating && !isVisible) {
    return null;
  }

  const classes = classNames(styles.container, { [styles.isVisible]: isVisible, [styles.isAnimating]: isAnimating }, className);
  const testId = `${testIdPrefix}-${isOpen ? 'open' : 'closed'}`;

  if (onClick) {
    return (
      <button
        aria-label={buttonLabel}
        className={classes}
        data-testid={testId}
        onClick={onClick}
        onAnimationEnd={onAnimationEnd}
        ref={ref as Ref<HTMLButtonElement>}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={classes} data-testid={testId} onAnimationEnd={onAnimationEnd} ref={ref as Ref<HTMLDivElement>}>
      {children}
    </div>
  );
});

export default LayerLegendContainer;
